<template>
  <div class="detail-page">
    <!-- 顶部导航栏 -->
    <el-header class="detail-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="goBack" class="back-btn">
        《 返回
      </el-button>
      <h2 class="detail-title">申请单详情</h2>
    </el-header>

    <!-- 详情内容容器 -->
    <div class="detail-content">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="spinner"></div>
        <p class="loading-text">加载详情中...</p>
      </div>

      <!-- 错误提示 -->
      <div v-else-if="errorMsg" class="error-container">
        <el-alert :message="errorMsg" type="error" show-icon :closable="false"></el-alert>
        <el-button type="primary" @click="fetchDetailData" class="retry-btn">重试</el-button>
      </div>

      <!-- 详情表单 -->
      <el-card v-else class="detail-card">
        <el-form :model="detailData" label-width="120px" class="detail-form">
          <!-- 审核信息区域 -->
          <el-form-item label="审核状态">
            <el-tag :type="statusType[detailData.reStatus]">
              {{ statusText[detailData.reStatus] }}
            </el-tag>
          </el-form-item>
          <!-- 1. 标签改为「提交时间」，展示含时分秒的完整时间 -->
          <el-form-item label="提交时间">
            <el-input v-model="detailData.createTime" disabled></el-input>
          </el-form-item>

          <!--学生基本信息区域-->
          <el-form-item label="姓名">
            <el-input v-model="detailData.reChildrenName" disabled></el-input>
          </el-form-item>
          <el-form-item label="年级">
            <el-input v-model="detailData.reChildrenGrade" disabled></el-input>
          </el-form-item>
          <el-form-item label="班级">
            <el-input v-model="detailData.reChildrenClass" disabled></el-input>
          </el-form-item>
          <el-form-item label="学校">
            <el-input v-model="detailData.reChildrenSchool" disabled></el-input>
          </el-form-item>

          <!-- 病例信息区域 -->
          <el-form-item label="就诊医院">
            <el-input v-model="detailData.reHospital" disabled></el-input>
          </el-form-item>
          <el-form-item label="患病名称">
            <el-input v-model="detailData.reDisease" disabled></el-input>
          </el-form-item>
          <el-form-item label="发病日期">
            <el-input v-model="detailData.reFallTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="诊断日期">
            <el-input v-model="detailData.reDiagnosisTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="主要症状状态">
            <el-input v-model="detailData.reSymptoms" disabled></el-input>
          </el-form-item>

          <!-- 症状显示逻辑：持续存在→显示详情；消失→显示消失时间 -->
          <el-form-item v-if="detailData.reSymptoms === '持续存在'" label="症状详情">
            <el-input v-model="detailData.reSymptomsOther" disabled type="textarea" :rows="3"></el-input>
          </el-form-item>
          <el-form-item v-if="detailData.reSymptoms === '症状消失'" label="症状消失时间">
            <el-input v-model="detailData.reSymptomsTime" disabled></el-input>
          </el-form-item>

          <!-- 证明文件预览 -->
          <el-form-item label="证明文件">
            <div v-if="detailData.reChildrenFile" class="file-preview">
              <el-image :src="detailData.reChildrenFile" alt="证明文件" fit="contain"
                :preview-src-list="[detailData.reChildrenFile]">
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                  <p>文件加载失败</p>
                </div>
              </el-image>
            </div>
            <span v-else class="no-file">未上传证明文件</span>
          </el-form-item>

          <!-- 审核意见区域 -->
          <el-divider content-position="left">审核意见</el-divider>
          <el-form-item label="审核结果" prop="auditResult">
            <el-radio-group v-model="auditForm.auditResult" @change="handleAuditResultChange">
              <el-radio label="pass">通过</el-radio>
              <el-radio label="reject">不通过</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 审核通过→显示同意复课时间 -->
          <el-form-item v-if="auditForm.auditResult === 'pass'" label="同意复课时间" prop="returnDate">
            <el-date-picker v-model="auditForm.returnDate" type="datetime" placeholder="选择复课日期" format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%;"></el-date-picker>
          </el-form-item>

          <!-- 审核不通过→显示拒绝原因下拉菜单 -->
          <el-form-item v-if="auditForm.auditResult === 'reject'" label="拒绝原因" prop="rejectReason">
            <el-select v-model="auditForm.rejectReason" placeholder="选择拒绝原因" @change="handleRejectReasonChange">
              <el-option label="材料不全" value="lack_material"></el-option>
              <el-option label="信息有误" value="wrong_info"></el-option>
              <el-option label="其他" value="other"></el-option>
            </el-select>
          </el-form-item>

          <!-- 拒绝原因为其他→显示其他原因输入框 -->
          <el-form-item v-if="auditForm.auditResult === 'reject' && auditForm.rejectReason === 'other'" label="其他原因"
            prop="otherReason">
            <el-input v-model="auditForm.otherReason" type="textarea" :rows="2" placeholder="请输入具体原因"></el-input>
          </el-form-item>

          <!-- 提交审核按钮 -->
          <el-form-item class="audit-submit">
            <el-button type="primary" @click="submitAudit">提交审核</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'ApplicationDetail',
  data() {
    return {
      loading: false,
      errorMsg: '',
      detailId: '',
      // 详情数据
      detailData: {
        re_submit_time: '',
        reChildrenName: '',
        reChildrenSfz: '',
        reChildrenGender: '',
        reChildrenAddress: '',
        reChildrenSchool: '',
        reChildrenGrade: '',
        reChildrenClass: '',
        reParentName: '',
        rePhone: '',
        reChildrenRelationship: '',
        reHospital: '',
        reDisease: '',
        reFallTime: '',
        reDiagnosisTime: '',
        reSymptoms: '', // 可能值："持续存在"、"症状消失"
        reSymptomsOther: '',
        reSymptomsTime: '',
        createTime: '', // 改为存储含时分秒的完整时间
        reStatus: '',
        reChildrenFile: '',
        reId: ''
      },
      // 审核表单数据
      auditForm: {
        auditResult: '', // pass=通过，reject=不通过
        returnDate: '', // 同意复课时间
        rejectReason: '', // 拒绝原因：lack_material/wrong_info/other
        otherReason: '' // 其他原因输入
      },
      // 状态映射
      statusText: {
        '0': '审核通过',
        '1': '待审核',
        '2': '审核拒绝'
      },
      statusType: {
        '0': 'success',
        '1': 'info',
        '2': 'danger'
      }
    };
  },
  mounted() {
    // 从路由参数中获取 'id' (此 id 即为 reId)
    this.detailId = this.$route.query.id || '';
    if (this.detailId) {
      this.fetchDetailData();
    } else {
      this.errorMsg = '未获取到有效的申请单ID。';
    }
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * 核心方法：获取详情数据
     */
    async fetchDetailData() {
      this.loading = true;
      this.errorMsg = '';

      try {
        const url = `/api/review/get/${this.detailId}`;
        const response = await request({
          url: url,
          method: 'get',
          timeout: 10000
        });

        const resData = typeof response === 'string' ? JSON.parse(response) : response;

        if (resData.code !== 200 || !resData.data) {
          throw new Error(resData.message || '服务器未返回有效数据。');
        }

        // 格式化数据：调用支持时分秒的formatDate函数
        this.detailData = {
          ...this.detailData,
          ...resData.data,
          // 2. 传入showTime=true，格式化含时分秒的提交时间
          createTime: this.formatDate(resData.data.createTime, true) || '未知',
          reFallTime: resData.data.reFallTime || '未填写',
          reDiagnosisTime: resData.data.reDiagnosisTime || '未填写',
          reSymptomsOther: resData.data.reSymptomsOther || '无',
          reSymptomsTime: resData.data.reSymptomsTime || '未填写'
        };

      } catch (error) {
        console.error('加载详情失败:', error);
        if (error.response) {
          const status = error.response.status;
          if (status === 404) {
            this.errorMsg = `未找到ID为 ${this.detailId} 的申请单。`;
          } else if (status === 500) {
            this.errorMsg = '服务器内部错误，请稍后重试或联系管理员。';
          } else {
            this.errorMsg = `请求失败，状态码: ${status}`;
          }
        } else {
          this.errorMsg = `详情加载失败：${error.message || '网络异常'}`;
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * 3. 重构日期格式化函数：支持展示时分秒
     * @param {string/number} dateStr - 后端返回的时间（字符串/时间戳）
     * @param {boolean} showTime - 是否展示时分秒，默认false
     * @returns {string} 格式化后的时间字符串
     */
    formatDate(dateStr, showTime = false) {
      if (!dateStr) return '';
      // 处理时间戳（10位转13位）
      if (typeof dateStr === 'number') {
        dateStr = dateStr.toString().length === 13 ? dateStr : dateStr * 1000;
      }
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr; // 解析失败返回原字符串

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      // 仅返回日期
      if (!showTime) {
        return `${year}-${month}-${day}`;
      }

      // 返回完整时间（年-月-日 时:分:秒）
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    /**
     * 审核结果变更：重置关联字段
     */
    handleAuditResultChange(val) {
      if (val === 'pass') {
        this.auditForm.returnDate = '';
        this.auditForm.rejectReason = '';
        this.auditForm.otherReason = '';
      } else if (val === 'reject') {
        this.auditForm.returnDate = '';
        this.auditForm.rejectReason = '';
        this.auditForm.otherReason = '';
      }
    },

    /**
     * 拒绝原因变更：选择非其他时清空输入框
     */
    handleRejectReasonChange(val) {
      if (val !== 'other') {
        this.auditForm.otherReason = '';
      }
    },

    /**
    * 提交审核（适配 /api/review/update 接口，提交成功跳转至医生审核页）
    */
    submitAudit() {
      // 表单校验（保持不变）
      if (!this.auditForm.auditResult) {
        this.$message.warning('请选择审核结果');
        return;
      }

      if (this.auditForm.auditResult === 'pass' && !this.auditForm.returnDate) {
        this.$message.warning('请选择同意复课时间');
        return;
      }

      if (this.auditForm.auditResult === 'reject') {
        if (!this.auditForm.rejectReason) {
          this.$message.warning('请选择拒绝原因');
          return;
        }
        if (this.auditForm.rejectReason === 'other' && !this.auditForm.otherReason.trim()) {
          this.$message.warning('请输入其他原因');
          return;
        }
      }

      // 新增：症状持续存在且审核通过时，弹出确认提示框
      if (this.detailData.reSymptoms === '持续存在' && this.auditForm.auditResult === 'pass') {
        this.$confirm(
          '当前申请单主要症状状态为“持续存在”，确认依然通过该审核吗？',
          '提示',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          // 点击确认：执行审核提交逻辑
          this.doSubmitAudit();
        }).catch(() => {
          // 点击取消：返回不提交，给出提示
          this.$message.info('已取消审核提交');
        });
        return;
      }

      // 其他情况（非持续存在/审核不通过）直接提交
      this.doSubmitAudit();
    },

    /**
     * 实际提交审核的核心逻辑（抽离为单独方法，便于复用）
     */
    doSubmitAudit() {
      // 构造审核数据（严格匹配后端字段要求）
      const auditData = {
        reId: this.detailId, // 申请单ID（关联数据库记录）
        reOpinion: this.auditForm.auditResult === 'pass' ? 0 : 1, // 0=同意，1=不同意
        reStatus: this.auditForm.auditResult === 'pass' ? 0 : 2, // 0=通过，2=不通过
        reOpinionTime: this.auditForm.auditResult === 'pass' ? this.auditForm.returnDate : '', // 同意复课时间
        // 拒绝原因处理：其他原因存具体内容，否则存下拉选项中文
        reOpinionOther: this.auditForm.auditResult === 'reject'
          ? (this.auditForm.rejectReason === 'other'
            ? this.auditForm.otherReason.trim()
            : this.auditForm.rejectReason === 'lack_material' ? '材料不全' : '信息有误')
          : ''
      };

      // 调用后端要求的 /api/review/update 接口
      request({
        url: '/api/review/updateDoctor', // 后端指定接口地址
        method: 'put', // 按后端要求使用 PUT 方法
        data: auditData, // 传递构造好的字段数据
        timeout: 10000
      }).then(response => {
        const resData = typeof response === 'string' ? JSON.parse(response) : response;
        if (resData.code === 200) {
          this.$message.success('审核提交成功！');
          // 提交成功后，延迟 500ms 跳转到医生审核页面（yishengshenhe）
          setTimeout(() => {
            this.$router.push('/yishengshenhe'); // 跳转至医生审核页路由路径
          }, 500);
        } else {
          this.$message.error(`审核提交失败：${resData.message || '服务器错误'}`);
        }
      }).catch(error => {
        console.error('审核提交失败:', error);
        this.$message.error('审核提交失败：网络异常');
      });
    }
  }
};
</script>

<style scoped>
/* 页面基础样式 */
.detail-page {
  background-color: #f9f9f9;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.detail-header {
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.back-btn {
  color: #666;
  font-size: 16px;
  margin-right: 20px;
}

.detail-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  font-weight: 500;
}

/* 内容容器 */
.detail-content {
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
}

/* 加载状态 */
.loading-container {
  background-color: #fff;
  padding: 60px 0;
  border-radius: 4px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 16px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #666;
  font-size: 14px;
}

/* 错误提示 */
.error-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  text-align: center;
}

.retry-btn {
  margin-top: 16px;
}

/* 详情卡片 */
.detail-card {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: none;
}

.detail-form {
  padding: 20px;
}

.detail-form .el-form-item {
  margin-bottom: 16px;
}

/* 审核意见区域样式 */
.el-divider {
  margin: 20px 0;
}

.audit-submit {
  margin-top: 20px;
  text-align: center;
}

/* 文件预览 */
.file-preview {
  width: 100%;
  max-width: 300px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.file-preview img {
  width: 100%;
  height: auto;
  min-height: 150px;
}

.image-error {
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
  background-color: #f5f5f5;
}

.image-error i {
  font-size: 32px;
  margin-bottom: 8px;
}

.no-file {
  color: #999;
  font-size: 14px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .detail-header {
    padding: 0 15px;
    height: 50px;
  }

  .detail-title {
    font-size: 16px;
  }

  .detail-content {
    padding: 15px;
  }

  .detail-form {
    padding: 15px;
  }

  .detail-form .el-form-item {
    margin-bottom: 12px;
  }

  .el-form-item__label {
    font-size: 14px !important;
    width: 100px !important;
  }

  .file-preview {
    max-width: 100%;
  }
}
</style>